<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog"
             center
             :close-on-click-modal="false" :append-to-body="true"
             :modal="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row>
        <!--<el-col :span="12">-->
          <!--<el-form-item label="证书名称" :label-width="formLabelWidth" prop="certname">-->
            <!--<el-input v-model="form.certname" :required="true"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="12">
          <el-form-item label="证号" :label-width="formLabelWidth" prop="certno">
            <el-input v-model="form.certno" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格型号" :label-width="formLabelWidth">
            <el-input v-model="form.model" :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="发证日期" :label-width="formLabelWidth" prop="sendtime">
            <el-date-picker style="width:100%"
                            v-model="form.sendtime" :value-format="'yyyy-MM-dd'"
                            type="date" :required="true"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" :label-width="formLabelWidth" prop="endtime">
            <el-date-picker style="width:100%"
                            v-model="form.endtime" :value-format="'yyyy-MM-dd'"
                            type="date" :required="true"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" v-if="form.certtype=='1'">
          <el-form-item label="关联商品" :label-width="formLabelWidth" prop="seedcode">
            <el-input placeholder="请选择商品" v-model="form.showname" size="small" :required="true" clearable @click.native="showGoodDetailSel"
                      @clear="clearSeedCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.certtype=='2'">
          <el-form-item label="关联供应商" :label-width="formLabelWidth" >
          <AutoCustomer :unitgroup="''" @clear="clearPcustomer" :content="form.showname"  @handleSelect="afterSelPcustomer"
                        placeholder="搜索，enter键结束" ></AutoCustomer>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业名称" :label-width="formLabelWidth" prop="certorg">
            <el-input v-model="form.certorg" :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="附件" :label-width="formLabelWidth" prop="attachguid">
            <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attachguid"
                          groupType="cert" :limit="10"></CommonUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" v-model="form.remark" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <diV hidden>
        <el-row>
          <el-col :span="24">
            <el-form-item label="" :label-width="formLabelWidth" prop="unitguid">
              <el-input v-model="form.unitguid" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </diV>
      <el-row>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData">确 定</el-button>
    </div>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
  </el-dialog>
</template>
<script>
  import {saveData, getDetail} from '@/api/set/certmanage';
  import {independentDept} from '@/api/set/dept';
  import {attUUID} from '@/api/attachment';
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: "certEdit",
    data() {
      return {
        title:'',
        dialogFormVisible: false,
        form: {  //表单数据
          unitguid: '',
          certtype: '',
          certname: '',
          certno: '',
          sendtime: '',
          certorg: '',
          model:'',
          endtime: '',
          seedcode: '',
          customerserial: '',
          typename: '',
          remark: '',
          attachguid: '',
          showname: '',
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          certname: [
            {required: true, message: '请输入证书名称', trigger: 'blur'},
          ],
          certno: [
            {required: true, message: '请输入证书编号', trigger: 'blur'},
          ],
          sendtime: [
            {required: true, message: '请输入发证日期', trigger: 'blur'},
          ],
          endtime: [
            {required: true, message: '请输入有效期', trigger: 'blur'},
          ],
          certorg: [
            {required: true, message: '请输入企业名称', trigger: 'blur'},
          ],
          seedcode: [
            {required: true, message: '请选择商品', trigger: 'blur'},
          ],
          // customerserial: [
          //   {required: true, message: '请选择企业', trigger: 'blur'},
          // ],
        },
      }
    },
    methods: {
      showtitle(){
        this.title=this.form.certtype=='1'?'产品证书':'企业证书';
      },
      //清空商品
      clearSeedCode() {
        this.form.seedcode = ""
        this.form.showname = ""
      },
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.form.seedcode = row.seedcode
        this.form.showname = row.seedname
      },
      clearPcustomer() {
        this.form.showname = ""
        this.form.customerserial = ""
      },
      //查询条件的供应商之后执行
      afterSelPcustomer(customerserial, customername, row) {
        this.form.showname = customername
        this.form.customerserial = customerserial
      },
      add(certtype) {
        this.form.certtype=certtype
        this.form.attachguid = attUUID();
        this.dialogFormVisible = true;
        this.showtitle();
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            saveData(this.form).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;

              //刷新列表
              this.$emit('bindGrid');
            });
            //
          }
        })
      },
      initData(unitguid) {
        this.initForm();
        this.dialogFormVisible = true;
        getDetail({unitguid: unitguid}).then(response => {
          this.form = response.data.obj
          this.showtitle();
        })
      },
      initForm() {
        this.form.unitguid = '';
        this.form.certname = '';
        this.form.certno = '';
        this.form.sendtime = '';
        this.form.certorg = '';
        this.form.model='';
        this.form.endtime = '';
        this.form.seedcode = '';
        this.form.customerserial = '';
        this.form.typename = '';
        this.form.remark = '';
        this.form.showname = '';
        if (this.$refs.refattguid) {
          this.$refs.refattguid.reset();
        }
      }
    },

    mounted() {
    },
    components: {
      JxcgooddetailSel,
    }
  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }
</style>



// WEBPACK FOOTER //
// src/components/set/cert/certEdit.vue